import React from 'react'
import {connect} from 'react-redux'
import { withTranslation } from 'react-i18next'
import { getUrls } from '../redux/oauth'
import { OAUTH_TYPE } from '../utils/constant'
import { reportOAuthClick } from '../utils/report'

import googleIcon from '../assets/img/google.svg'
import githubIcon from '../assets/img/github.svg'
import gitlabIcon from '../assets/img/gitlab.png'
import giteeIcon from '../assets/img/gitee.png'

class OAuth extends React.Component {
  constructor (props) {
    super(props)
    this.props.dispatch(getUrls())
  }
 
  handleOAuthClick = () => {
    reportOAuthClick()
  }

  render() {
    const { t } = this.props
    const { urls = {} } = this.props

    return (
      <div className='oauth'>
        {t('signup.thirdPartyLogin')}:&nbsp;
        <a href={urls[OAUTH_TYPE.GOOGLE]} onClick={this.handleOAuthClick}><img src={googleIcon} style={{height: 26}} alt='Google'/></a>
        <a href={urls[OAUTH_TYPE.GITHUB]} onClick={this.handleOAuthClick}><img src={githubIcon} style={{height: 26}} alt='Github'/></a>
        <a href={urls[OAUTH_TYPE.GITLAB]} onClick={this.handleOAuthClick}><img src={gitlabIcon} style={{height: 26}} alt='Gitlab' /></a>
        <a href={urls[OAUTH_TYPE.GITEE]} onClick={this.handleOAuthClick}><img src={giteeIcon} style={{height: 26}} alt='Gitee' /></a>
      </div>
    )
  }
}

OAuth = connect((state) => {
  return {
    urls: state.oauth.urls
  }
})(OAuth)


OAuth = withTranslation()(OAuth)

export default OAuth
